<h1 mat-dialog-title>
  {{ model ? 'Editar Variables' : 'Agregar Variables' }}
</h1>

<form [formGroup]="form" (submit)="model ? update(form.value) : create(form.value)" appPermissionControl="P203F0001">
  <div mat-dialog-content>
    <mat-grid-list [cols]="breakpoint" rowHeight="90px" (window:resize)="onResize($event)">
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Perfil</mat-label>
            <input matInput placeholder="123" formControlName="clavePerfil" type="text" [readonly]="modelRecived" appPermissionControl="P203K0001" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>No. Variable</mat-label>
            <input matInput placeholder="Ejemplo..." formControlName="variable" type="number" [readonly]="modelRecived" appPermissionControl="P203K0002" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Archivo</mat-label>
            <mat-select formControlName="tabla" required (selectionChange)="onChangeSelect($event)" appPermissionControl="P203K0003">
              <mat-option *ngFor="let opcion of opciones" [value]="opcion.valor">
                {{ opcion.opcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="comboCampo">
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Campo</mat-label>
            <mat-select formControlName="campo" required appPermissionControl="P203K0004">
              <mat-option *ngFor="let item of campoOpciones" [value]="item.valor">
                {{ item.opcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="comboTipo">
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="tipo" required appPermissionControl="P203K0005">
              <mat-option *ngFor="let tipo of campoTipos" [value]="tipo.valor">
                {{ tipo.opcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="comboPop">
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Campo</mat-label>
            <mat-select formControlName="campo" required appPermissionControl="P203K0006">
              <mat-option *ngFor="let item of campoOpciones" [value]="item.clavePerfil">
                {{ item.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="fechaEdo">
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Estatus Fecha</mat-label>
            <input matInput placeholder="123" formControlName="fechaEdo1" type="date" [readonly]="modelRecived" appPermissionControl="P203K0007" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="fechaEdo">
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Estatus Fecha</mat-label>
            <input matInput placeholder="123" formControlName="fechaEdo2" type="date" [readonly]="modelRecived" appPermissionControl="P203K0008" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="campoProc">
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Campo</mat-label>
            <input matInput placeholder="123" formControlName="campo" type="number" [readonly]="modelRecived" appPermissionControl="P203K0009" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="model">
        <ng-container>
          <button mat-raised-button type="button" color="accent" (click)="openRangos()" appPermissionControl="P203B0001"><mat-icon>align_horizontal_right</mat-icon> Rangos</button>
        </ng-container>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <div mat-dialog-actions>
    <ng-container *ngIf="!loading"
      ><button class="botonFm btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P203B0002">Cancelar</button>
      <button class="botonFm" mat-raised-button color="accent" appPermissionControl="P203B0003">
        {{ modelRecived ? 'Actualizar' : 'Guardar' }}
      </button>
    </ng-container>
    <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P203B0004">
      Cargando
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </button>
  </div>
</form>
